import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import ManualPage from '../modules/manual/ManualPage';
import './HelpSheet.css';

// Layer 4 of the in-app help stack: the page-level "?" (see App.js's
// module-actions) opens this right-side sheet rather than a centred modal —
// the screen underneath stays visible. Reuses ManualPage itself rather than
// duplicating the browse/read UI, so there's exactly one place that knows
// how to list and render an article.
function HelpSheet({ open, onOpenChange, articleSlug }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="help-sheet-overlay" />
        <Dialog.Content className="help-sheet-content">
          <Dialog.Title className="help-sheet-title">Optim Commerce Manual</Dialog.Title>
          <Dialog.Description className="help-sheet-description">
            Browse or search the Manual without leaving this screen.
          </Dialog.Description>
          <Dialog.Close asChild>
            <button type="button" className="help-sheet-close" aria-label="Close">
              <X size={16} strokeWidth={2} />
            </button>
          </Dialog.Close>
          <div className="help-sheet-body">
            <ManualPage initialSlug={articleSlug} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default HelpSheet;
